export default class VersionUtil {
  static isOlder(version: string, than: string): boolean {
    const a = version.split('.').map(Number)
    const b = than.split('.').map(Number)
    if ([...a, ...b].some(Number.isNaN)) return false
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
      const difference = (a[i] ?? 0) - (b[i] ?? 0)
      if (difference !== 0) return difference < 0
    }
    return false
  }
}
